export default __webpack_public_path__ + "static/media/img-1.9654bd8a.png";